import { GenericReminderDialog } from "~/components/reminders/reminder-dialog";
import type { TClientSettings } from "~/database/types";

interface ReminderDialogProps {
    sessionId: string;
    sessionName: string;
    effectiveSettings?: TClientSettings | null;
    /** Controlled open + hidden trigger, for driving this from a menu item. */
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    hideTrigger?: boolean;
}

export const ReminderDialog: React.FC<ReminderDialogProps> = ({
    sessionId,
    sessionName,
    effectiveSettings,
    open,
    onOpenChange,
    hideTrigger,
}) => {
    const description = effectiveSettings?.enableIntegrationsTab
        ? "Schedule a reminder to come back for a guided meditation based on your session."
        : "Schedule a reminder to come back and read through your session for integration.";

    return (
        <GenericReminderDialog
            entityType="session"
            entityId={sessionId}
            entityName={sessionName}
            description={description}
            analyticsId="Schedule session reminder"
            triggerLabel="Remind"
            open={open}
            onOpenChange={onOpenChange}
            hideTrigger={hideTrigger}
        />
    );
};
